// src/utils/constants.js
export const CLINIC_INFO = {
    name: 'Bokundara Dental Surgery',
    phone: process.env.REACT_APP_PHONE_NUMBER || '0714680485',
    whatsappNumber: process.env.REACT_APP_WHATSAPP_NUMBER || '94714680485',
    email: 'info@bokundaradentalclinic.com',
    appointmentEmail: 'appointments@bokundaradentalclinic.com',
    address: 'no 322/1, Colombo road, Bokundara, Piliyandala 10300',
    hours: {
        weekdays: '9:00 AM - 6:00 PM',
        weekend: '10:00 AM - 4:00 PM',
    },
    logo : '/images/bkdental_logo.png'
};

export const SERVICES_DEFAULT = [
    {
        id: 1,
        name: 'General Dental Check-ups',
        icon: '/images/or_04.jpeg',
        description:
            'Routine dental check-ups help detect cavities, gum disease, and other oral problems early. Our dentists perform a thorough examination of your teeth, gums, and oral tissues to maintain long-term oral health.',
    },
    {
        id: 2,
        name: 'Dental Fillings (Tooth-coloured restorations)',
        icon: '/images/or_09.jpeg',
        description:
            'We use high-quality tooth-coloured (composite) fillings to restore decayed or damaged teeth. These fillings blend naturally with your teeth while restoring strength and function.',
    },
    {
        id: 3,
        name: 'Scaling, Cleaning & Polishing',
        icon: '/images/or_08.jpeg',
        description:
            'Professional scaling and polishing remove plaque, tartar, and stains that cannot be removed by brushing alone. This treatment helps prevent gum disease and keeps your teeth clean and fresh.',
    },
    {
        id: 4,
        name: 'Root Canal Treatments (Including nerve fillings)',
        icon: '/images/or_06.jpeg',
        description:
            'Root canal treatment is performed to save infected or severely decayed teeth. The infected nerve is removed, the canal is cleaned, and the tooth is sealed to relieve pain and prevent further infection.',
    },
    {
        id: 5,
        name: 'Oral & Minor Surgical Procedures',
        icon: '/images/or_05.jpeg',
        description:
            'We perform minor oral surgical procedures such as surgical removal of wisdom teeth, difficult extractions, and treatment of minor oral lesions, following strict sterilization and safety protocols.',
    },
    {
        id: 6,
        name: 'Braces & Orthodontic Treatments',
        icon: '/images/or_07.jpeg',
        description:
            'Orthodontic treatments help correct misaligned teeth and bite problems. We offer braces and other orthodontic solutions to improve both appearance and oral function.',
    },
    {
        id: 7,
        name: 'Dentures (Flexible & Metal-based)',
         icon: '/images/or_10.jpeg',
        description:
            'We provide comfortable and natural-looking dentures, including flexible and metal-based options, to replace missing teeth and restore chewing ability and confidence.',
    },
    {
        id: 8,
        name: 'Crowns & Bridges',
        icon: '/images/or_02.jpeg',
        description:
            'Crowns and bridges are used to restore damaged or missing teeth. They improve strength, appearance, and function while maintaining a natural look.',
    },
    {
        id: 9,
        name: 'Teeth Whitening',
        icon: '/images/or_03.jpeg',
        description:
            'Professional teeth whitening helps remove stains and discoloration, giving you a brighter and more confident smile using safe and effective techniques.',
    },
    {
        id: 9,
        name: 'Dental Implants',
        icon: '/images/or_01.jpeg',
        description:
            'Dental implants are a permanent and natural-looking solution for missing teeth. They restore chewing efficiency, appearance, and help preserve jawbone health.',
    }
];

export const DOCTORS_DEFAULT = [
    {
        id: 1,
        name: 'Dr. Sudeha Duwagamge',
        specialty: 'Dental Surgeon (BDS (SL), MSc (Colombo))',
        experience: '14 years of experience from both government and private practices',
        image: '👨‍⚕️',
    },
    {
        id: 2,
        name: 'Dr. K. A. Gammulle',
        specialty: 'Dental Surgeon (BDS (SL), MSc (Colombo))',
        experience: '14 years of experience from both government and private practices',
        image: '👩‍⚕️',
    }
    // ,
    // {
    //     id: 3,
    //     name: 'Dr. Amit Kumar',
    //     specialty: 'BDS, MDS Prosthodontics',
    //     experience: 'Specialist in implants and restorative dentistry',
    //     image: '👨‍⚕️',
    // },
];

export const TESTIMONIALS_DEFAULT = [
    {
        id: 1,
        text: 'Amazing experience! Dr. Sharma is very professional and caring. Highly recommended!',
        author: 'Raj Kumar',
        rating: 5,
    },
    {
        id: 2,
        text: 'Best dental clinic in the city. Staff is friendly and the treatment is top-notch!',
        author: 'Priya Singh',
        rating: 5,
    },
    {
        id: 3,
        text: 'Very clean facility and comfortable. No pain during procedures. Will visit again!',
        author: 'Amit Patel',
        rating: 5,
    },
];

export const HIGHLIGHTS_DEFAULT = [
    {
        id: 1,
        title: 'Expert Dentists',
        icon: '⭐',
        description: '15+ years of experience in modern dentistry',
    },
    {
        id: 2,
        title: 'State-of-the-art Facility',
        icon: '🏥',
        description: 'Latest dental technology and equipment',
    },
    {
        id: 3,
        title: 'Patient Care First',
        icon: '💙',
        description: 'Comfortable environment and compassionate care',
    },
];
